import { ca } from '@cian/analytics';
import { EPageBlock } from '../../../../types/analytics';
import { INewbuildingPromoV2 } from '../../../../types/promosPage';

export const trackFreshPromoListShow = (promoList: INewbuildingPromoV2[]) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'show_sopr',
    label: 'Block',
    page: {
      extra: {
        block: EPageBlock.NewPromo,
        newbuilding_id: promoList.map(({ newbuildingId }) => newbuildingId),
      },
    },
  });
};

export const trackFreshPromoCardClick = ({ newbuildingId }: INewbuildingPromoV2) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'Click',
    label: 'Block',
    page: {
      extra: {
        block: EPageBlock.NewPromo,
        newbuilding_id: newbuildingId,
      },
    },
  });
};
